module.exports = __webpack_public_path__ + "static/img/lk.0412697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/lk.png
// module id = Aft1
// module chunks = 18